import React, { useEffect, useRef } from "react";
import { TextField } from "@mui/material";

const RevisionExcelCellEditor = ({
  config,
  value,
  error,
  row,
  cell,
  table,
  saving,
  onChange,
  onMove,
  onSave,
  onVerify,
  onExit,
}) => {
  const inputRef = useRef(null);
  const entryValue = useRef(value ?? "");

  useEffect(() => {
    inputRef.current?.focus();
    inputRef.current?.select?.();
  }, []);

  const handleKeyDown = (event) => {
    const shortcut = event.ctrlKey || event.metaKey;

    if (shortcut && event.key.toLowerCase() === "s") {
      event.preventDefault();
      event.stopPropagation();
      onSave();
      return;
    }

    if (shortcut && event.key === "Enter") {
      event.preventDefault();
      event.stopPropagation();
      onVerify();
      return;
    }

    if (event.key === "Escape") {
      event.preventDefault();
      event.stopPropagation();
      onChange(entryValue.current);
      table.setEditingCell(null);
      onExit(cell.id);
      return;
    }

    if (event.key === "Tab") {
      event.preventDefault();
      event.stopPropagation();
      onMove(row, cell, table, event.shiftKey ? -1 : 1);
      return;
    }

    if (event.key === "Enter" && !config.multiline) {
      event.preventDefault();
      event.stopPropagation();
      onMove(row, cell, table, 1);
    }
  };

  const handleBlur = () => {
    queueMicrotask(() => {
      if (table.getState().editingCell?.id === cell.id) table.setEditingCell(null);
    });
  };

  return (
    <TextField
      inputRef={inputRef}
      fullWidth
      size="small"
      variant="standard"
      type={config.type}
      multiline={config.multiline}
      minRows={config.multiline ? 2 : undefined}
      value={value ?? ""}
      error={Boolean(error)}
      helperText={error || undefined}
      disabled={saving}
      onChange={(event) => onChange(event.target.value)}
      onKeyDown={handleKeyDown}
      onBlur={handleBlur}
      inputProps={{
        maxLength: config.maxLength,
        "aria-label": `Editar ${config.label} del registro ${row.original.id}`,
      }}
      InputLabelProps={config.type === "date" ? { shrink: true } : undefined}
      sx={{ minWidth: Math.min(config.size || 140, 220) }}
    />
  );
};

export default RevisionExcelCellEditor;
